<template>
	<div class="container member-chain-form">
		<div class="common-header-wrap">
			<mt-header :title="getTitle" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>

		<div class="main-content">
			<flex-line class="field-line" :show-border="true"><span class="field-name">姓名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="address_info.address_realname" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">手机</span><div class="field-line-right" slot="right"><input class="field-input" v-model="address_info.address_mob_phone" /></div></flex-line>
			<flex-line :is-link="true" :show-border="true">
				<span>地区</span>
				<div @click="onRegion" slot="right">
					<span v-if="address_info.area_info">{{address_info.area_info}}</span>
					<span v-else>请选择地区</span>
				</div>
			</flex-line>
			<flex-line :is-link="true" :show-border="true">
				<span>代收点</span>
				<div @click="showChain=true" slot="right">
					<span v-if="address_info.address_detail">{{address_info.address_detail}}</span>
					<span v-else>请选择代收点</span>
				</div>
			</flex-line>
			<flex-line :show-border="true"><span class="line-name">默认地址</span><div slot="right"><mt-switch v-model="address_info.address_is_default"></mt-switch></div></flex-line>
			<div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">{{getSumitTitle}}</div></div>

		</div>
		<region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>
		<mt-popup v-model="showChain" position="right" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header title="代收点列表" class="common-header">
					<mt-button slot="left" icon="back" @click="showChain=false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content">
				<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
					<div v-if="chainList && chainList.length">
						<div class="top-wrapper" v-for="(item,index) in chainList" :key="index" @click="setChain(item)">
							<div class="title-wrapper">
								<label class="title">{{ item.chain_addressname }}</label>
								<label class="title">{{ item.chain_mobile }}<span v-if="item.chain_telephony">{{ item.chain_telephony }}</span></label>
							</div>
							<label class="desc address-text">{{item.chain_area_info}}&nbsp;{{item.chain_address}}</label>
							<div class="bottom-line"></div>
						</div>
					</div>
					<empty-record v-else-if="chainList && !chainList.length"></empty-record>
				</div>
			</div>
		</mt-popup>
	</div>
</template>

<script>
import { getPointByAddress } from '../../../util/bmap'
import { Toast, Indicator } from 'mint-ui'
import RegionPicker from '../../../components/RegionPicker'
import EmptyRecord from '../../../components/EmptyRecord'
import { getAddressInfo, addChain, getChainList } from '../../../api/memberAddress'
import flexLine from '../../flexLine'
export default {
  components:{
    flexLine,
    RegionPicker,
    EmptyRecord
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增地址'
      } else {
        return '修改收货地址'
      }
    },
    getSumitTitle () {
      let isFromCheckout = this.$route.query.isFromCheckout
      if (isFromCheckout) {
        return '保存并使用'
      } else {
        return '保存'
      }
    }
  },
  data () {
    return {
      chainList: [],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      showChain: false,
      popMap: false,
      address_id: 0,
      address_info: {
		  address_is_default: true
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.address_id = this.$route.query.address_id
      getAddressInfo(this.address_id).then(res => {
        this.address_info = res.result.address_info

        if (res.result.address_info.address_is_default === '1') {
          this.address_info.address_is_default = true
        } else {
          this.address_info.address_is_default = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    loadMore () {
      if (this.loading) {
        return
      }

      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = true
        this.getChainList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.chainList = false
      this.loadMore()
    },
    getChainList () {
      getChainList(this.params, this.address_info.area_id).then(res => {
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        if (this.chainList) {
          this.chainList = this.chainList.concat(res.result.chain_list)
        } else {
          this.chainList = res.result.chain_list
        }
        this.loading = false
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
        this.loading = false
      })
    },
    setChain (item) {
      this.address_info.chain_id = item.chain_id
      this.address_info.address_detail = item.chain_address
      this.showChain = false
      this.$forceUpdate()
    },
    goBack () {
      this.$router.go(-1)
    },
    getPosition () {
      getPointByAddress(this.address_info.area_info + this.address_info.address_detail).then(res => {
        if (res.result.location) {
          this.address_info.address_longitude = res.result.location.lng
          this.address_info.address_latitude = res.result.location.lat
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.address_info.address_detail = name
      this.address_info.address_longitude = lng
      this.address_info.address_latitude = lat
    },
    submit () {
      if (this.address_info.address_realname === '') {
        Toast('请填写收件人姓名')
        return
      }
      if (this.address_info.address_realname.length === 0) {
        Toast('请填写收件人姓名')
        return
      }
      if (this.address_info.address_realname.length < 2 || this.address_info.address_realname.length > 15) {
        Toast('2-15个字符限制')
        return
      }
      if (this.address_info.address_mob_phone === '') {
        Toast('请填写手机号码')
        return
      }
      if (this.address_info.address_mob_phone.length === 0) {
        Toast('请填写手机号码')
        return
      }
      if (this.address_info.area_id === 0 || this.address_info.area_id === undefined) {
        Toast('请选择所在地区')
        return
      }
      if (this.address_info.chain_id === 0 || this.address_info.chain_id === undefined) {
        Toast('请选择代收点')
        return
      }

      addChain(this.address_info).then(
        (response) => {
          Indicator.close()
          this.updateSelectedAddress()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
        })
    },
    onRegion (picker, values) {
      this.$refs.picker.currentValue = true
    },
    onPickerConfirm (values) {
      if (this.address_info.area_id != values[2].area_id) {
        this.address_info.chain_id = 0
        this.address_info.address_detail = ''
      }
      this.address_info.area_info = this.getRegionStr(values)

      this.address_info.area_id = values[2].area_id
      this.address_info.city_id = values[1].area_id
      this.reload()
      this.$forceUpdate()
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    updateSelectedAddress () {
		this.$router.go(-2)
    }
  }
}
</script>
<style lang="scss">
	.member-chain-form .address-line-wrapper .mint-cell-title{flex:unset;width: 5rem}
	.member-chain-form .address-line-wrapper .mint-cell-value{flex:1;text-align: right;    display: block;}
</style>
<style lang="scss" scoped>
	.main-content{background: #fff;padding:0 $pageSpace}
	.right-arrow{transform: rotate(-90deg);color:#ddd;font-size:$fontSize;display: inline-block;}
	.input-wrap{position: relative;
		i{position: absolute;right:0;top:0;line-height: 2.4rem;display: block;width:2rem;text-align: center;font-size:$h1}
	}
	.top-wrapper {
		position: relative;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
	}
	.top-wrapper .title-wrapper {
		height:1rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-top:0.5rem;
		margin-left:0.5rem;
	}
	.top-wrapper .title {
		font-size:$h2;
		color: #333;
		margin-left:0.5rem;
	}
	.top-wrapper .desc {
		color: #7c7f88;
		font-size:$subFontSize;
	}
	.top-wrapper .address-text {
		margin-top:0.5rem;
		margin-bottom:0.5rem;
		margin-left:1rem;
		margin-right:0.5rem;
	}
	.top-wrapper .bottom-line {
		position: absolute;
		height: 1px;
		left:0.5rem;
		bottom: 0;
		right:0.5rem;
		background-color: #e8eaed;
	}
	.address-line{display: inline-block;max-width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap}
</style>
